import React from "react";
import { Link } from "react-router-dom";
import LegalDocument from "../templates/LegalDocument/legal-document";

export default function PrivacyPolicy() {
  return (
    <LegalDocument title="Privacy Policy" effectiveDate="10 September 2026">
      <p>
        This Privacy Policy explains how ORIGIN GAME processes personal data in
        connection with the public website at oxyaorigin.com. Separate products,
        applications, competitions or marketplaces may be governed by their own
        privacy information.
      </p>

      <h2>1. Data controller</h2>
      <p>
        The data controller is ORIGIN GAME, a French simplified joint-stock
        company (SAS) with share capital of EUR 5,000, registered with the Paris
        Trade and Companies Register under number 911 609 394, whose registered
        office is at 229 rue Saint-Honore, 75001 Paris, France.
      </p>
      <p>
        Privacy enquiries and requests may be sent to{" "}
        <a href="mailto:contact@oxyaorigin.com">contact@oxyaorigin.com</a>.
      </p>

      <h2>2. Data we process</h2>
      <h3>Website delivery and security</h3>
      <p>
        When the website is requested, technical data such as IP address,
        request time, requested URL, browser information and security signals
        may be processed to deliver the site, prevent abuse and maintain its
        security and availability. Cloudflare provides hosting, delivery and
        security services for this purpose.
      </p>

      <h3>Audience measurement</h3>
      <p>
        If you allow analytics, Google Analytics may process page views,
        approximate location, device and browser information, referrer data and
        interaction information. Google Analytics does not load unless you give
        consent through the cookie controls.
      </p>

      <h3>External media</h3>
      <p>
        YouTube videos remain blocked until you allow external media. Once
        allowed, Google may receive technical and interaction data when a video
        is loaded or played, under Google's own terms and privacy information.
      </p>

      <h3>Messages and partnership enquiries</h3>
      <p>
        If you contact us by email or submit a linked partnership form, we may
        process the information you provide, such as your name, contact details,
        organisation, message and related correspondence.
      </p>

      <h2>3. Purposes and legal bases</h2>
      <ul>
        <li>
          Website delivery, fraud prevention and security: our legitimate
          interests in operating and protecting the website.
        </li>
        <li>
          Google Analytics and YouTube: your consent, which may be refused or
          withdrawn at any time.
        </li>
        <li>
          Responding to enquiries: steps requested before a possible contract,
          or our legitimate interest in managing professional communications.
        </li>
        <li>
          Legal and regulatory obligations: compliance with applicable law.
        </li>
      </ul>

      <h2>4. Recipients</h2>
      <p>
        Access is limited to authorised ORIGIN GAME personnel and service
        providers that need the data for the purposes above. These providers may
        include Cloudflare for website delivery and security, and Google for
        consented analytics, YouTube content and linked Google Forms. We do not
        sell personal data.
      </p>

      <h2>5. International transfers</h2>
      <p>
        Some providers may process data outside the European Economic Area.
        Where required, transfers are covered by an applicable adequacy decision,
        standard contractual clauses or another lawful transfer mechanism.
      </p>

      <h2>6. Retention</h2>
      <ul>
        <li>Cookie preferences are stored for six months.</li>
        <li>
          Google Analytics cookies are configured for no more than thirteen
          months without renewal, and event-level analytics data are retained
          for no more than fourteen months.
        </li>
        <li>
          Technical security data are kept only for the period needed for site
          delivery, abuse prevention and applicable legal obligations, according
          to the active provider configuration.
        </li>
        <li>
          Correspondence is kept for the time needed to handle the request and
          establish or defend legal claims.
        </li>
      </ul>

      <h2>7. Your rights</h2>
      <p>
        Subject to applicable conditions, you may request access, correction,
        erasure, restriction or portability of your personal data, object to
        processing based on legitimate interests, and withdraw consent at any
        time without affecting earlier lawful processing. You may also provide
        instructions concerning your personal data after death where French law
        applies.
      </p>
      <p>
        Send requests to{" "}
        <a href="mailto:contact@oxyaorigin.com">contact@oxyaorigin.com</a>. We may
        ask for information needed to verify your identity. You may lodge a
        complaint with the French data protection authority, the CNIL, at{" "}
        <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">
          cnil.fr
        </a>
        .
      </p>

      <h2>8. Cookie choices</h2>
      <p>
        Optional technologies remain disabled until you allow them. You can
        change your choices at any time through Cookie Settings in the footer.
        Details are available in our <Link to="/cookie-policy">Cookie Policy</Link>.
      </p>

      <h2>9. Children</h2>
      <p>
        This public website is not intended to collect personal data directly
        from children. A parent or guardian who believes that a child has sent
        us personal data may contact us to request its deletion.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update this policy when our practices or legal obligations change.
        The effective date above identifies the current public version.
      </p>
    </LegalDocument>
  );
}
